module.exports = __webpack_public_path__ + "img/Angeschlagen.3df0d21b.svg";